import InformationModal from './informationModal'

export default InformationModal
